<script>
  import { createEventDispatcher } from "svelte";

  import { initSchemaValues } from "./utils.js";

  import Group from "./group.svelte";

  import { _ } from "./utils.js";

  export let openapi;
  export let schema;
  export let layout = 'default';
  export let value;
  export let errors;
  export let dirty;
  export let canBeSubmitted;
  export let loading;
  export let editable = false;
  export let currentPath;
  export let texts = undefined;
  export let extras = undefined;

  let fieldsLayout;

  $: schema, init();

  const init = () => {
    if (schema && !fieldsLayout) {
      value = value || initSchemaValues(schema);

      if (schema.ui?.forms && schema.ui.forms[layout]) {
        fieldsLayout = schema.ui.forms[layout];
      } else {
        const fields = [];
        for (const property of Object.keys(schema.properties)) {
          fields.push({ type: 'field', id: property})
        }
        if (schema.ui && (!Object.keys(schema.ui).includes('buttons') || schema.ui.buttons)) {
          const buttons = { type: "buttons" };
          if (schema.ui.submitText) buttons.submitText = schema.ui.submitText;
          if (schema.ui.cancel) buttons.cancel = schema.ui.cancel;
          fields.push(buttons);
        }
        fieldsLayout = { type: 'group', contents: fields };
      }
    }
  }

  const dispatch = createEventDispatcher();
</script>

{#if fieldsLayout}
  <Group
    { openapi } { schema }
    layout={ fieldsLayout } { errors }
    { editable }
    currentPath={ [ ...currentPath, fieldsLayout ] }
    { texts } { extras }
    bind:value={ value } bind:canBeSubmitted={ canBeSubmitted } bind:loading={ loading }
    bind:dirty={ dirty }
    on:cancel={ () => { dispatch('cancel') } } on:message={ ({ detail }) => { dispatch('message', detail) } }
  >

    <svelte:fragment slot="array-widgets" let:addArrayWidget={ addArrayWidget } let:removeArrayWidget={ removeArrayWidget }>
      <slot name="array-widgets" { addArrayWidget } { removeArrayWidget }></slot>
    </svelte:fragment>
    <svelte:fragment slot="wallet-yours" let:value={ value } let:setValue={ setValue }>
      <slot name="wallet-yours" { value } { setValue } />
    </svelte:fragment>

  </Group>
{:else}
  { _("Loading", texts, "Loading") }
{/if}